import React from 'react';
import {CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner} from '@coreui/react';

interface Props {
    aberto: boolean,
    titulo: string,
    children: React.ReactNode,
    rotuloConfirmar?: string,
    corConfirmar?: string,
    processando?: boolean,
    onConfirmar: () => void,
    onFechar: () => void
}

/**
 * Confirmação antes de uma ação que não tem volta (excluir, cancelar execução...).
 * O botão de confirmar fica desabilitado enquanto a ação roda, para não disparar duas vezes.
 */
const ConfirmModal = ({aberto, titulo, children, rotuloConfirmar = 'Confirmar', corConfirmar = 'danger', processando = false, onConfirmar, onFechar}: Props) => (
    <CModal show={aberto} onClose={onFechar} centered>
        <CModalHeader closeButton>
            <CModalTitle>{titulo}</CModalTitle>
        </CModalHeader>
        <CModalBody>{children}</CModalBody>
        <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={onFechar} disabled={processando}>Voltar</CButton>
            <CButton color={corConfirmar} onClick={onConfirmar} disabled={processando}>
                {processando && <CSpinner size="sm" className="mr-2"/>}
                {rotuloConfirmar}
            </CButton>
        </CModalFooter>
    </CModal>
);

export default ConfirmModal;
